module.exports = __webpack_public_path__ + "static/brand06-40c4895a47c9e8a9941365d28e139bea.png";